module.exports = __webpack_public_path__ + "static/media/bgform.f295cfbd.jpg";